<div class="default-padding" [ngStyle]="{ 'background-image': 'url(' + headerBgLink + ')' }">
  <div class="header-main default-max-width centered">
    <button class="header-main-opener js-header-main-opener" (click)="toggelMenu.emit()">
      <div></div>
      <div></div>
      <div></div>
    </button>

    <a [routerLink]="'/' | localizeUrlPath" class="header-main-logo">
      <img [src]="logoLink" alt="Logo" />
    </a>

    <div class="header-main-search" *appIsBrowser>
      <mat-form-field class="header-main-category">
        <mat-select [(ngModel)]="selectedCategoryPath" name="categoryPath" panelClass="header-main-category-panel">
          <mat-option [value]="catalogRootPath">{{ "core.header-search.all-categories" | transloco }}</mat-option>
          <mat-option *ngFor="let category of (topLevelCategories$ | async) ?? []; trackBy: trackByUrlPath" [value]="category.sUrlPath">
            {{ category.sTitle }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-header-search [categoryPath]="selectedCategoryPath"></app-header-search>
    </div>

    <div class="mobile-hidden tablet-hidden">
      <app-header-nav *appIsBrowser class="header-nav mobile-hidden"></app-header-nav>
    </div>
  </div>
</div>
